import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import {
  GlobalStyle,
  LoginContainer,
  LoginBox,
  LoginHeader,
  LogoContainer,
  LoginContent,
  FormGroup,
  FormControl,
  LoginButton,
  ResetLink,
  ErrorMessage,
  ErrorText
} from './Login.style';
import Logo from './Logo.style';

import auth from 'utils/auth';
import { Redirect } from 'react-router-dom';

const LoginComponent = () => {
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [hasFailedLogin, setHasFailedLogin] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    try {
      // Handle login logic here
      await auth.login(data.username, data.password);
      setShouldRedirect(true);
    } catch (error) {
      console.error(error);
      console.log('login error');

      setHasFailedLogin(error.message);
    }
  };

  if (shouldRedirect) {
    // get nexturl, if saved and redirect to it or to root if not set
    let nextUrl = '/';

    if (window.sessionStorage.getItem('nextUrl')) {
      nextUrl = window.sessionStorage.getItem('nextUrl');
    }

    return <Redirect to={nextUrl} />;
  }

  return (
    <>
      <GlobalStyle />
      <LoginContainer>
        <LoginBox>
          <LoginHeader>
            <LogoContainer>
              <Logo />
            </LogoContainer>
          </LoginHeader>
          <LoginContent>
            {hasFailedLogin && (
              <ErrorMessage>
                <>
                  <p>
                    <FormattedMessage id="login.authError.leadingMessage" />
                  </p>
                  <p>
                    <FormattedMessage id="login.authError.secondaryMessage" />
                  </p>
                </>
              </ErrorMessage>
            )}
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <FormGroup>
                <label htmlFor="username">Username</label>
                <FormControl
                  type="text"
                  id="username"
                  placeholder="Enter your username"
                  autoFocus
                  {...register('username', { required: 'Username is required' })}
                />
                {errors.username && <ErrorText>{errors.username.message}</ErrorText>}
              </FormGroup>
              <FormGroup>
                <label htmlFor="password">Password</label>
                <FormControl
                  type="password"
                  id="password"
                  placeholder="Enter your password"
                  autoComplete="new-password"
                  {...register('password', { required: 'Password is required' })}
                />
                {errors.password && <ErrorText>{errors.password.message}</ErrorText>}
              </FormGroup>
              <ResetLink href="resetPassword">Forgot password?</ResetLink>
              <LoginButton type="submit">Login</LoginButton>
            </form>
          </LoginContent>
        </LoginBox>
      </LoginContainer>
    </>
  );
};

export default LoginComponent;
